import React from "react";
import { Modal, Button } from "react-bootstrap";

const VendorDetailModal = ({ show, onHide, vendor }) => {
  if (!vendor) return null;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Vendor Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Vendor Name:</strong>{" "}
          {vendor.id_user ? vendor.id_user.name : "N/A"}
        </p>
        <p>
          <strong>On-Boarding Date : </strong>{" "}
          {formatDate(vendor.onBoardingDate)}
        </p>
        <p>
          <strong>Phone Number:</strong>{" "}
          {vendor.id_user ? vendor.id_user.phonenumber : "N/A"}
        </p>
        <p>
          <strong>Home Number:</strong> {vendor.homenumber}
        </p>
        <p>
          <strong>Temporary Address:</strong> {vendor.tempaddress}
        </p>
        <p>
          <strong>City:</strong> {vendor.city}
        </p>
        <p>
          <strong>State:</strong> {vendor.state}
        </p>
        <p>
          <strong>Permanent Address:</strong> {vendor.permanentaddress}
        </p>
        <p>
          <strong>Coordinates:</strong>{" "}
          {vendor.coordinates ? (
            <>
              <span>
                <strong>Latitude:</strong> {vendor.coordinates.latitude}
              </span>
              <span>, </span>
              <span>
                <strong>Longitude:</strong> {vendor.coordinates.longitude}
              </span>
            </>
          ) : (
            <span>N/A</span>
          )}
        </p>
        <p>
          <strong>Description:</strong> {vendor.description}
        </p>
        <p>
          <strong>Status:</strong> {vendor.status}
        </p>
        <p>
          <strong>Created By:</strong>{" "}
          {vendor.createdBy && (
            <>
              <span>
                <strong>Name:</strong> {vendor.createdBy.user_email}
              </span>
              <span>, </span>
              <span>
                <strong>Role:</strong> {vendor.createdBy.user_role}
              </span>
            </>
          )}
        </p>
        <p>
          <strong>Created Date:</strong>{" "}
          {vendor.createdAt && (
            <>{new Date(vendor.createdAt).toLocaleDateString()}</>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VendorDetailModal;
